export class StorePriceImportModel {
  counter: number = 0;
  branchCode: number = 0;
  storeCode: number = 0;
  articleCode: number = 0;
  unitValue: number = 0;

  constructor(counter: number,
    branchCode: number,
    storeCode: number,
    articleCode: number,
    unitValue: number
  ) {
    this.counter = counter;
    this.branchCode = branchCode;
    this.storeCode = storeCode;
    this.articleCode = articleCode;
    this.unitValue = unitValue;
  }
}